export default "__VITE_ASSET__BHkUiRtP__";